import PropTypes from 'prop-types';
import React from 'react';
import GridBlock from '../layout/grid-block.jsx';
import { SimpleImage as Image } from '$partials/media/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
*/
const TextPageMediaGridModule = ({
    gridItems = []
}) => {
    const gridHeight = Math.max(...gridItems.map((item) => item.top + item.height));
    let smAvailableWidth = 7;
    let lgAvailableWidth = 9;

    return (
        <section className='w-full h-full relative mt-1 overflow-hidden bg-background'>
            {/* background cells */}
            <div className={`absolute hidden sm:grid h-full w-full top-0 left-0 grid-cols-3 sm:grid-cols-7 lg:grid-cols-9 -mr-1 grid-rows-${gridHeight}`}>
                {[...Array(gridHeight * 9)].map((_, i) => {
                    const showSm = i < gridHeight * 7 ? 'sm:block' : 'sm:hidden';
                    const showMd = i < gridHeight * 7 ? 'md:block' : 'md:hidden';
                    const showLg = i < gridHeight * 9 ? 'lg:block' : 'lg:hidden';

                    return (
                        <div
                            className={`relative aspect-1/1 hidden ${showSm} ${showMd} ${showLg}`}
                            key={`spacer-${i}`}>
                            <div className='absolute top-0 bottom-0 left-0 right-0 mr-1 mb-1 bg-foreground rounded overflow-hidden' />
                        </div>
                    );
                })}
            </div>

            {/* mobile + sm + md */}
            <div className={`top-0 bottom-0 left-0 right-0 grid grid-cols-3 sm:grid-cols-7 lg:hidden -mr-1 sm:grid-rows-${gridHeight}`}>
                {gridItems.length > 0 && (
                    gridItems.map((item) => {
                        if (!item) { return null; }

                        const width = Math.min(smAvailableWidth, item.width);
                        smAvailableWidth = smAvailableWidth - width;
                        const left = Math.min(smAvailableWidth, item.left);
                        smAvailableWidth = smAvailableWidth - left;

                        return (
                            <GridBlock
                                {...item}
                                key={item?.id}
                                left={left}
                                spacerClassName='opacity-0'
                                width={width}>
                                <Image
                                    {...item.image}
                                    className='w-full h-full object-cover' />
                            </GridBlock>
                        );
                    })
                )}
            </div>

            {/* lg */}
            <div className={`hidden lg:grid op-0 bottom-0 left-0 right-0 grid-cols-9 -mr-1 grid-rows-${gridHeight}`}>
                {gridItems.length > 0 && (
                    gridItems.map((item) => {
                        if (!item) { return null; }

                        const width = Math.min(lgAvailableWidth, item.width);
                        lgAvailableWidth = lgAvailableWidth - width;
                        const left = Math.min(lgAvailableWidth, item.left);
                        lgAvailableWidth = lgAvailableWidth - left;

                        return (
                            <GridBlock
                                {...item}
                                key={item?.id}
                                left={left}
                                spacerClassName='opacity-0'
                                width={width}>
                                <Image
                                    {...item.image}
                                    className='w-full h-full object-cover' />
                            </GridBlock>
                        );
                    })
                )}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    gridItems: PropTypes.arrayOf(PropTypes.shape({
        height: PropTypes.number.isRequired,
        id: PropTypes.string.isRequired,
        top: PropTypes.number.isRequired,
    })).isRequired
};

TextPageMediaGridModule.propTypes = propTypes;

export default TextPageMediaGridModule;
